import React, { PropTypes } from 'react'

//import user from '../user'
import AppBar from 'material-ui/AppBar';

const styles = {
  appBar: { position: 'fixed' }
}

const TopNav = () => (
  <AppBar
    title='videre Segmentation Tool'
    showMenuIconButton={false}
    style={styles.appBar}
  />
)

export default TopNav



// WEBPACK FOOTER //
// ./src/app/TopNav.js